import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { transectionApi } from "../../app/slices/transectionSlice";
import { Box, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContentCopy } from "@mui/icons-material";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import ToastComponent from "./../../components/customTable/ToastComponent";

export default function Transection() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    dispatch(transectionApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector(
    (state) => state.transection.transection.data
  );

  const stateLoading = useSelector(
    (state) => state.transection.loading
  );
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("Price", {
      header: "Price",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>₹{cell.row.original?.Price}</div>
      ),
    }),
    columnHelper.accessor("amount", {
      header: "Amount",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>₹{cell.row.original?.amount}</div>
      ),
    }),
    columnHelper.accessor("client_id", {
      header: "Client ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.client_id);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.client_id}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.clientName || "Batuk Customer"}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("commission", {
      header: "Commission",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.commission || "0"}
        </div>
      ),
    }),

    columnHelper.accessor("gst", {
      header: "GST",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>₹{cell.row.original?.gst}</div>
      ),
    }),
    columnHelper.accessor("invoice_No", {
      header: "Invoice No",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.invoice_No}
        </div>
      ),
    }),

    columnHelper.accessor("invoice_url", {
      header: "Invoice URL",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.invoice_url);
          toast.success("URL copied to clipboard!");
        };

        return (
          <Tooltip title="Copy URL">
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("merchant_transaction_id", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchant_transaction_id
          );
          toast.success("copied to clipboard!");
        };


        return (
          <Tooltip title={cell.row.original?.merchant_transaction_id}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchant_transaction_id}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("metal_type", {
      header: "Metal Type",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.metal_type}
        </div>
      ),
    }),
    columnHelper.accessor("orderID", {
      header: "Order ID",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.orderID}</div>
      ),
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partnerName}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("payment_id", {
      header: "Payment ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.payment_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.payment_id}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.payment_id}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("payment_method", {
      header: "Payment Method",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.payment_method}
        </div>
      ),
    }),
    columnHelper.accessor("proposal_id", {
      header: "Proposal ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.proposal_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.proposal_id}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.proposal_id}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("proposal_no", {
      header: "Proposal No",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.proposal_no}
        </div>
      ),
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.quantity}</div>
      ),
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.status}</div>
      ),
    }),
    columnHelper.accessor("total_amount", {
      header: "Total Amount",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          ₹{cell.row.original?.total_amount}
        </div>
      ),
    }),
    columnHelper.accessor("transaction_id", {
      header: "Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transaction_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transaction_id}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transaction_id}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  return (
    <>
     {/*  */}
      <DateSearchComponent onSearch={handleSearch} />
      <Box mt={2}>
        <CustomTable columns={columns} data={sliceResponse} loading={stateLoading}
        permissionKey="Transactions"
        />
      </Box>

    </>
  );
}
